<template>
    <section class="step__main">
      <slot name="header"></slot>
  
      <section class="status__contain">
        <section class="status__template" v-if="isLoading">
        
          <section class="description remove__gap">
            <br>
            <v-icon x-large color="success">mdi-account-check</v-icon>
            <h3>Login Realizado com Sucesso!!</h3>
            <small>Você será redirecionado automaticamente.</small>
          </section>
        </section>
  
        <section class="status__template" v-if="!isLoading && !isSuccess">
          <Animation :animationData="defaultOptions" :weight="84" :height="84" />
  
          <section class="description remove__gap">
            <h3>Login Não Realizado</h3> 
          </section>
  
          <v-btn class="btn__default" color="primary" text @click="restartLogin">
            Tentar novamente
          </v-btn>
        </section>
    </section>
</section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import LoginService from "@/service/auth/LoginService";
import setAuthData from "@/service/auth/AuthService";
export default {
  name: "LoggedUser",

  data: () => ({
    isLoading: true,
    isSuccess: false,
  }), 

  computed: {
    ...mapGetters({
      userCredentials: "getUserLogin",
      storeResouce: "getUserNoAuth",
      selectedUnityAndProfile: "getUnityAndProfile",
    }), 

    isChangeData() {
      return Object.keys(this.selectedUnityAndProfile).length;
    },
  },

  components: { },

  async created() {
    this.loggingUser();
  },

  methods: {
    ...mapActions(["changeUnityAndProfile", "changeSnackbarData"]),
    ...mapMutations(['setSessionData']),

    async loggingUser() { 
      const isChange = this.isChangeData;

      const unityAndProfile = isChange
        ? this.selectedUnityAndProfile
        : {
            unity_id: this.storeResouce.unity_id,
            profile_id: this.storeResouce.profile_id,
          };

      const userData = {
        ...this.userCredentials,
        ...unityAndProfile,
      };

       try {
        await LoginService.login(userData)

        const authMeData = await setAuthData();
        this.setSessionData(authMeData);

        setTimeout(() => {
          this.$router.push({ name: "Dashboard" });
        }, 1000);

      }catch(err) { 
        this.changeSnackbarData([
          true,
          "error",
          "Erro ao realizar login",
          err.response?.data?.details || err.error,
        ])
      }
    },

    restartLogin() {
      this.$emit("goToStart");
      this.changeUnityAndProfile({});
    },
  },
};
</script>

<style lang="scss" scoped>
.step__main {
  .status__contain {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 335px;
    height: 100%;
    position: absolute;
    top: 0;

    .status__template {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 25px;
      text-align: center;

      .description {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .remove__gap {
        margin-top: -25px;
      }
    }
  }
}
</style>
